import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import { services } from "@/data/services";

const Services = () => (
  <PageLayout>
    <Seo
      title="Property Services Melbourne – Oz Property Services Co."
      description="Interior upgrades, outdoor improvements, maintenance, security and renovation support across Melbourne, coordinated by one reliable team."
      path="/services"
    />
    <PageHero
      title="Our Property Services"
      subtitle="Interior upgrades, outdoor improvements, maintenance, security and renovation support — all coordinated by one reliable team."
    />
    <section className="bg-white py-16 md:py-24">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-8">
          {services.map((s) => (
            <div key={s.slug} id={s.slug} className="bg-card rounded-2xl p-8 scroll-mt-24">
              <div className="flex items-center gap-4 mb-5">
                <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center shrink-0">
                  <s.icon className="w-6 h-6 text-dark" />
                </div>
                <h2 className="text-2xl font-black text-dark">{s.title}</h2>
              </div>
              <p className="text-muted-foreground leading-relaxed mb-6">{s.desc}</p>
              <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3 mb-2">
                {s.items.map((item) => (
                  <li key={item} className="flex gap-2.5 text-dark font-medium text-sm">
                    <span className="text-yellow font-black">›</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-muted-foreground mt-12 max-w-2xl mx-auto">
          Licensed trades can be coordinated where required.
        </p>

        <div className="mt-8 text-center">
          <Link
            to="/get-quote"
            className="inline-block bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity"
          >
            Request a Quote
          </Link>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default Services;
